import { Component, Inject, Input, Output } from '@angular/core';
import { PageService } from '../../services/page.service';

@Component({
  selector: 'mob-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {

  @Input() show:boolean = false;
  @Input() title?:string = 'Carregando';
  @Input() subtitle?:string = 'Por favor, aguarde ...';

  constructor(@Inject(PageService) public pageService: PageService) { }

}
